import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header.jsx';
import Footer from './Footer.jsx';
import FloatingActionButtons from '../common/FloatingActionButtons.jsx';

const MainLayout = () => {
  return (
    <div className="w-full max-w-full overflow-x-hidden">
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
      <Header />
      <main id="main-content" className="w-full max-w-full overflow-x-hidden">
        <Outlet />
      </main>
      <FloatingActionButtons />
      <Footer />
    </div>
  );
};

export default MainLayout;
